import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";
import { BUSINESS, PAGES } from "@/lib/site";

const CRUMBS = [{ name: "Home", path: "/" }, { name: "Legal", path: "/legal" }];

const Block = ({ id, title, children }) => (
  <section id={id} className="scroll-mt-28 border-t border-neutral-200 py-10">
    <h2 className="font-display text-2xl font-bold tracking-tight sm:text-3xl">{title}</h2>
    <div className="mt-5 space-y-4 text-base leading-relaxed text-neutral-600">{children}</div>
  </section>
);

export default function Legal() {
  return (
    <>
      <Seo {...PAGES.legal} path="/legal" crumbs={CRUMBS} />
      <PageHeader crumbs={CRUMBS} eyebrow="The fine print" title="Legal &" highlight="compliance" lead="Age requirements, health disclaimer, ordering and privacy." />
      <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6" data-testid="legal-page">
        <Block id="compliance" title="Age & eligibility">
          <p>This website is intended only for adults aged 21 or older. District Gaslight is an ABCA-licensed medical cannabis retailer in Washington, DC. Purchases require valid government-issued photo ID and a qualifying medical cannabis patient registration.</p>
          <p>Cannabis remains illegal under federal law. Do not transport cannabis across state lines. Do not drive or operate machinery under the influence. Keep products out of reach of children and pets.</p>
        </Block>
        <Block id="health" title="Health disclaimer">
          <p>Nothing on this website is medical advice, and we make no claims that any product diagnoses, treats, cures or prevents any condition. Talk with a qualified healthcare provider about whether cannabis is right for you.</p>
        </Block>
        <Block id="ordering" title="Online ordering">
          <p>Our online menu, cart and checkout are provided by Dutchie. Product details, pricing, availability and order processing come from Dutchie and our live inventory, and are subject to <a className="text-gas underline underline-offset-4" href="https://dutchie.com/privacy" target="_blank" rel="noopener noreferrer">Dutchie's privacy policy</a> and terms.</p>
        </Block>
        <Block id="privacy" title="Privacy">
          <p>This website does not ask you to create an account or submit personal information. We store your age confirmation in your browser for the current session only. Analytics, if enabled, run only after you accept them in the consent banner.</p>
          <p>Questions? Contact us at <a className="font-bold text-brand-red underline underline-offset-4" href={BUSINESS.phoneHref}>{BUSINESS.phone}</a>.</p>
        </Block>
        <Block id="terms" title="Terms of use">
          <p className="rounded-xl border border-dashed border-brand-red/60 bg-brand-sand p-4 text-sm text-brand-ink" data-testid="legal-terms-placeholder">
            [Placeholder — District Gaslight's full terms of use and privacy policy should be supplied or reviewed by the business's legal counsel before launch.]
          </p>
        </Block>
        <p className="pt-6 text-sm"><Link to="/" className="font-bold underline underline-offset-4">Back to home</Link></p>
      </div>
    </>
  );
}
